import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ShoppingRecurrence,
  ShoppingRecurrenceCycle,
  ShoppingRecurrenceRepository
} from '@infrab4a/connect';
import { retry } from 'rxjs';
import { ConnectRequest } from 'src/app/models';
import { environment } from 'src/environments/environment';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopShoppingRecurrenceService extends BaseConnectService<ShoppingRecurrence> {
  private get cloudFunctionsUrl(): string {
    return `https://southamerica-east1-${environment.connectFirebase.projectId}.cloudfunctions.net`;
  }

  constructor(
    @Inject('ShoppingRecurrenceRepository')
    private recurrenceRepository: ShoppingRecurrenceRepository,
    private httpClient: HttpClient
  ) {
    super(recurrenceRepository);
  }

  async getById(id: string): Promise<ShoppingRecurrence> {
    return this.recurrenceRepository.get({ id });
  }

  async getRecurrencesList(request: Partial<ConnectRequest>) {
    const result = await this.paginatedSearch(request);
    const content = result.data.map((recurrence) => ({ ...recurrence }));
    const totalPages = request.pageSize
      ? Math.floor(result.count / request.pageSize)
      : undefined;
    const totalElements = result.count;

    return {
      totalPages,
      totalElements,
      content,
      empty: result.count === 0
    };
  }

  enableOrDisableShoppingRecurrence(recurrenceId: string, active: boolean) {
    return this.httpClient
      .post(`${this.cloudFunctionsUrl}/enableOrDisableShoppingRecurrence`, {
        recurrenceId,
        active
      })
      .pipe(retry(1));
  }

  updateShoppingRecurrenceFrequency(
    recurrenceId: string,
    frequency: ShoppingRecurrenceCycle
  ) {
    return this.httpClient
      .post(`${this.cloudFunctionsUrl}/updateShoppingRecurrenceFrequency`, {
        recurrenceId,
        frequency
      })
      .pipe(retry(1));
  }
}
